import React from 'react'

interface PageHeaderProps {
  /** Page title — the big display heading at the top of a screen. */
  title: string
  /** Optional intro line beneath the title (secondary copy). */
  intro?: React.ReactNode
}

/**
 * Page heading + intro — the title block at the top of a screen, the first
 * child of PageShell. Distinct from a section header (the smaller heading
 * inside each card lower down the page).
 *
 * Spacing (locked): 12px between the title and intro, 32px below the whole
 * block. Use this on every screen so the type and spacing can't drift between
 * screens — don't hand-roll the h1 + p again.
 */
export function PageHeader({ title, intro }: PageHeaderProps) {
  return (
    <div style={{ marginBottom: 'var(--spacing-8)' }}>
      <h1
        style={{
          fontFamily: 'var(--font-display)',
          fontSize: 'var(--text-display-sm)',
          fontWeight: 'var(--weight-semibold)',
          color: 'var(--color-text-primary)',
          margin: '0 0 var(--spacing-3) 0',
          lineHeight: 'var(--leading-tight)',
        }}
      >
        {title}
      </h1>
      {intro != null && (
        <p
          style={{
            fontFamily: 'var(--font-body)',
            fontSize: 'var(--text-body-md)',
            color: 'var(--color-text-secondary)',
            margin: 0,
            lineHeight: 'var(--leading-normal)',
          }}
        >
          {intro}
        </p>
      )}
    </div>
  )
}
